
export enum FiltersMode {
    NONE = 0,
    BASIC = 1,
    ALL = 2
}
